import React from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import constants from '../../constants';
import PreviewModuleBottomMenuItem from './PreviewModuleBottomMenuItem';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import MenuArrow from '../svg/MenuArrow';
import SearchGlass from '../svg/SearchGlass';
import Checkin from '../svg/preview/Checkin';

class PreviewStudioC extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default PreviewStudioC;
